/* 🤖 this file was generated by svg-to-ts */
export const DfIconPin12: {
  name: 'pin-12';
  data: string;
} = {
  name: 'pin-12',
  data: `<svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M6 0a4 4 0 0 1 4 4c0 1.013-.63 2.59-1.89 4.73l-.36.598-.39.626-.423.654-.453.682L6 12a73.538 73.538 0 0 1-.484-.71l-.454-.682-.421-.654-.391-.626-.36-.598c-.286-.486-.54-.944-.761-1.372l-.25-.5C2.293 5.643 2 4.69 2 4a4 4 0 0 1 4-4zm0 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z"/></svg>`
};
